module.exports = __webpack_public_path__ + "img/07.c0c62d48.png";